import { Pipe, PipeTransform } from '@angular/core';
import { Translator } from 'angular-translator';
/*
 * Dada una key pasada como argumento, retorna una
 * representacion legible.
 * Toma como argumento un string.
 *
 * Uso:
 *   key | humanize
 *
 * Ejemplo:
 *
 *   {{ 'TABLA_SIMPLE' | humanize }}
 *
 *   retorna: 'Tabla Simple'
*/
@Pipe({ name: 'humanize' })
export class HumanizePipe implements PipeTransform {

  constructor(private translator: Translator) {
  }

  transform(key: string): string {
    const mappingKeys = {
      //#region data types
      'String': <string>this.translator.instant('HUM_STRING'),
      'Decimal': <string>this.translator.instant('HUM_DECIMAL'),
      'Int32': <string>this.translator.instant('HUM_INT32'),
      'Int64': <string>this.translator.instant('HUM_INT64'),
      'Boolean': <string>this.translator.instant('HUM_BOOLEAN'),
      'Email': <string>this.translator.instant('HUM_EMAIL'),
      'TABLA': <string>this.translator.instant('HUM_SYSTEM_TABLE'),
      'TABLA_SIMPLE': <string>this.translator.instant('HUM_SIMPLE_TABLE'),
      'LIST': <string>this.translator.instant('HUM_ATTRIBUTE_LIST'),
      'Custom': <string>this.translator.instant('HUM_CUSTOM'),
      'DateTime': <string>this.translator.instant('HUM_DATETIME'),
      //#endregion

      //#region Provider operations
      'Quotation': <string>this.translator.instant('HUM_QUOTATION'),
      'Sale': <string>this.translator.instant('HUM_SALE'),
      'Endorsement': <string>this.translator.instant('HUM_ENDORSEMENT'),
      'ReportGenerator': <string>this.translator.instant('HUM_REPORTGENERATOR'),
      'ReportQuery': <string>this.translator.instant('HUM_REPORTQUERY'),
      //#endregion

      //#region Product Report Execution types 
      'ExecuteRuleBased': <string>this.translator.instant('HUM_RULE_BASED'),
      'ExecuteWordBased': <string>this.translator.instant('HUM_WORD_BASED'),
      'ExecutePDFBased': <string>this.translator.instant('HUM_PDF_BASED'),
      //#endregion

      //#region Column types
      'ATTRIBUTE': <string>this.translator.instant('HUM_PRODUCT_COLUMN'),
      'CUSTOM': <string>this.translator.instant('HUM_CUSTOM_COLUMN'),
      'DOCUMENT_COMPONENT': <string>this.translator.instant('HUM_COMMON_COLUMN'),
      //#endregion

      //#region Dynamic Styles
      'short': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'M/d/yy, h:mm a\' (6/15/15, 9:03 AM)',
      'medium': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'MMM d, y, h:mm:ss a\' (Jun 15, 2015, 9:03:01 AM)',
      'long': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'MMMM d, y, h:mm:ss a z\' (June 15, 2015 at 9:03:01 AM GMT+1)',
      'full': <string>this.translator.instant('HUM_EQUIVALENT_TO') +
        '\'EEEE, MMMM d, y, h:mm:ss a zzzz\' (Monday, June 15, 2015 at 9:03:01 AM GMT+01:00)',
      'shortDate': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'M/d/yy\' (6/15/15)',
      'mediumDate': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'MMM d, y\' (Jun 15, 2015)',
      'longDate': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'MMMM d, y\' (June 15, 2015)',
      'fullDate': <string>this.translator.instant('HUM_EQUIVALENT_TO') + '\'EEEE, MMMM d, y\' (Monday, June 15, 2015)'
      //#endregion
    };

    return mappingKeys[key] || '';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/humanize.pipe.ts